module.exports = __webpack_public_path__ + "img/system.7d1e8022.svg";